import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { RatingsComponent } from './ratings.component';
var ɵ0 = { title: 'RATINGS.TITLE' };
var routes = [
    {
        path: 'relatorios/avaliacoes',
        component: RatingsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var RatingsModule = /** @class */ (function () {
    function RatingsModule() {
    }
    return RatingsModule;
}());
export { RatingsModule };
export { ɵ0 };
